<div class="container" [ngClass]="ngClass" [id]="'item-'+ chatMessage?.id">
  <div class="message" *ngIf="chatMessage && !isSystemMessage; else system">
    <div class="message-avatar">
      <lin-avatar
        [source]="chatMessage.user.picture"
        [name]="chatMessage.user.name"
        [surName]="chatMessage.user.surname"
        [size]="AvatarSize.mds"
      >
      </lin-avatar>
    </div>
    <div class="message-container">
      <ng-container *ngIf="chatMessage.file">
        <ng-container *ngIf="isImageFile; else file">
          <ng-container *ngIf="fileStored">
            <img
              *ngIf="isImageLoaded | async; else imagePreview"
              [src]="imageSrc | async"
              class="message__picture"
              alt="attachment"
              (click)="handleImageClick()"
            />
            <lin-progress-bar [isShown]="(isImageLoading | async) && (isImageLoaded | async)"></lin-progress-bar>
          </ng-container>
          <div *ngIf="isImageFile" class="message__download-file" fxLayout="row" fxLayoutAlign="start center" (click)="downloadFile(true)">
            <img class="file" src="assets/images/chat/attach-file.svg" alt="file" />
            <span>{{ chatMessage.file.displayName }}</span>
          </div>
          <ng-template #imagePreview>
            <div class="message__picture-loading" *ngIf="(isImageLoading | async) === false; else loadingImage">
              <button mat-icon-button color="accent" aria-label="" (click)="handleImageLoad()">
                <mat-icon svgIcon="arrow_downward"></mat-icon>
              </button>
            </div>
          </ng-template>
          <ng-template #loadingImage>
            <div class="message__picture-loading">
              <mat-spinner strokeWidth="2" diameter="30" color="accent"></mat-spinner>
            </div>
          </ng-template>
        </ng-container>
        <ng-template #file>
          <lin-progress-bar [isShown]="(isImageLoading | async) && (isImageLoaded | async)"></lin-progress-bar>
          <div class="message__download-file" fxLayout="row" fxLayoutAlign="start center" (click)="downloadFile()">
            <img class="file" src="assets/images/chat/attach-file.svg" alt="file" />
            <span>{{ chatMessage.file.displayName }}</span>
          </div>
        </ng-template>
      </ng-container>
      <div class="message-body" [ngClass]="{ deleted: isDeletedMessage }" *ngIf="chatMessage.message">
        <span>{{ chatMessage.message }}</span>
      </div>
      <button *ngIf="isEditAvailable" class="message-edit" [matMenuTriggerFor]="userMenu">
        <mat-icon class="message-edit">more_vert</mat-icon>
      </button>

      <mat-menu #userMenu="matMenu" [overlapTrigger]="false">
        <button mat-menu-item (click)="handleMessageOptions(ChatMessageOption.EDIT)">
          {{ 'CLIENT.MESSENGER.CHAT_DETAILS.EDIT_MESSAGE' | translate }}
        </button>
        <button *ngIf="chatMessage.file" mat-menu-item (click)="handleMessageOptions(ChatMessageOption.DELETE_ATTACHMENT)">
          {{ 'CLIENT.MESSENGER.CHAT_DETAILS.DELETE_ATTACHMENT' | translate }}
        </button>
        <button mat-menu-item (click)="handleMessageOptions(ChatMessageOption.DELETE)">
          {{ 'CLIENT.MESSENGER.CHAT_DETAILS.DELETE_MESSAGE' | translate }}
        </button>
      </mat-menu>
    </div>
    <div class="message-date">
      <span *ngIf="chatMessage.updatedAt; else createdDate">
        ({{ 'CLIENT.MESSENGER.CHAT_DETAILS.MESSAGE_EDITED' | translate }}) {{ chatMessage.createdAt | dayjsFullTime }}
      </span>
      <ng-template #createdDate>
        <span>{{ chatMessage.createdAt | dayjsFullTime }}</span>
      </ng-template>
      <mat-icon [svgIcon]="isReadAll ? 'done_all' : 'done'"></mat-icon>
    </div>

    <div class="image-overlay" *ngIf="isOpenImageOverlay" fxLayoutAlign="center center">
      <div class="image-overlay__container" fxLayout="column">
        <mat-icon (click)="isOpenImageOverlay = !isOpenImageOverlay" class="image-overlay__cross-mark">close</mat-icon>
        <div class="image-overlay__image-container">
          <lin-progress-bar [isShown]="isImageLoading | async"></lin-progress-bar>
          <img class="image-overlay__image" *ngIf="isOriginalLoaded" [src]="imageOriginSource | async" alt="attachment" />
          <img class="image-overlay__image" *ngIf="!isOriginalLoaded" [src]="imageSrc | async" alt="attachment" />

          <div class="image-overlay__message-date">
            <div class="message__download-file" fxLayout="row" fxLayoutAlign="space-between center">
              <span (click)="downloadFile()" class="flex-item">
                <img class="file" src="assets/images/chat/attach-file.svg" alt="file" />
                {{ chatMessage.file.displayName }}
              </span>
              <span class="flex-item"> {{ (chatMessage.updatedAt || chatMessage.createdAt) | dayjsFullTime }} </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="this.chatMessage?.file && !fileStored" class="container system-message" [ngClass]="ngClass">
  <div>{{ 'CLIENT.MESSENGER.CHAT_DETAILS.FILE_NOT_AVAILABLE' | translate }}</div>
</div>

<ng-template #system>
  <span> {{ chatMessage.message }} </span>
  <span> {{ (chatMessage.updatedAt || chatMessage.createdAt) | dayjsFullTime}} </span>
</ng-template>
